import React ,{useState} from 'react'
import styled  from 'styled-components'
import Navbar from '../components/Navbar'
import Announcement from '../components/Announcement'
import NewsLetter from '../components/NewsLetter'
import Footer from '../components/Footer'
import Products from '../components/Products'
import {mobile} from "../responses"
import {useLocation} from "react-router-dom"

const Container=styled.div`
    height:70vh; 
    flex:1;
    margin:3px;
    position:relative;
`
const Title=styled.h1`
    margin: 20px;
`
const FilterContainer=styled.div`
    display: flex;
    justify-content: space-between;
    ${mobile({width:"100%",justifyContent:"center"})};

`
const Filter=styled.div`
    margin: 20px;
    ${mobile({width:"0% 20px",display:"flex",flexDirection:"column"})};
`
const FilterText=styled.span`
    font-size: 20px;
    font-weight: 600;
    margin-right: 20px;
    ${mobile({marginRight:"0"})};
`
const Select=styled.select`
     ${mobile({margin:"10px 0px"})};
        padding: 10px;
        margin-right: 20px;
`
const SelectOptions=styled.option`
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    padding: 20px;

`
const ProductList = () => {
  const location=useLocation();
  const cat=location.pathname.split('/')[2];
// console.log({cat});

  const [filters,setFilter]=useState({})
  const [sort,seSort]=useState("newest")
  // console.log(filters);
  
  const handleChange=(e)=>{
    const value=e.target.value
    setFilter({
      ...filters,
      [e.target.name]:value
    })
  }
  return (
    <Container>
      <Navbar/>
      <Announcement/>
      <Title>
        {cat?.toUpperCase()||"Products Trending"}
      </Title>
      <FilterContainer>
            <Filter>
               <FilterText>Filter Products</FilterText>
               <Select name="color"  onChange={handleChange}>
                    
                    <SelectOptions disabled selected>Color</SelectOptions>
                    <SelectOptions>White</SelectOptions>
                    <SelectOptions>Black</SelectOptions>
                    <SelectOptions>Blue</SelectOptions>
                    <SelectOptions>Yellow</SelectOptions>
                    <SelectOptions>Green</SelectOptions>
                    <SelectOptions>Pink</SelectOptions>
                    <SelectOptions>ALL</SelectOptions>
               </Select>
               <Select name="size" onChange={handleChange}>
                    <SelectOptions disabled selected>Size</SelectOptions>
                    <SelectOptions>XS</SelectOptions>
                    <SelectOptions>S</SelectOptions>
                    <SelectOptions>M</SelectOptions>
                    <SelectOptions>L</SelectOptions>
                    <SelectOptions>XL</SelectOptions>
                    <SelectOptions>ALL</SelectOptions> 
               </Select>
            </Filter>
            <Filter>
            <FilterText>Sort Products</FilterText>

            <Select onChange={e=>seSort(e.target.value)}>
                    <SelectOptions value="newest" selected>Newest</SelectOptions>

                    <SelectOptions value="asc">Price (asc)</SelectOptions>
                    <SelectOptions value="desc">Price (desc)</SelectOptions>
               </Select>
            </Filter>
      </FilterContainer>
      <Products cat={cat} filters={filters} sort={sort}/>
      <NewsLetter/>
      <Footer/>
    </Container>
  )
}

export default ProductList
